import { createApi } from '@reduxjs/toolkit/query/react';
import { apiEndpoints } from 'Utils/ApiEndpoints';
import { createAuthBaseQuery } from './baseQuery';

export const commonApi = createApi({
    reducerPath: 'commonApi',
    baseQuery: createAuthBaseQuery(),
    tagTypes: ['CommonData', 'Faq'],
    endpoints: (builder) => ({
        getCommonData: builder.query({
            query: () => ({
                url: apiEndpoints?.commonContentUrl,
                method: 'GET',
            }),
            providesTags: ['CommonData'],
        }),
        getPromptData: builder.query({
            query: () => ({
                url: apiEndpoints?.promptDataUrl,
                method: 'GET',
            }),
            providesTags: ['CommonData'],
        }),
        getPromptDetailsData: builder.query({
            query: ({ prompt_id }) => ({
                url: `${apiEndpoints?.getPromptDetailsDataUrl}?prompt_id=${prompt_id}`,
                method: 'GET',
            }),
            providesTags: ['CommonData'],
        }),
        updateCommonData: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.commonContentUpdateUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['CommonData'],
        }),
        UpdatePromptData: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updatePromtDataUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['CommonData'],
        }),
        getFaq: builder.query({
            query: () => ({
                url: apiEndpoints?.faqGetUrl,
                method: 'GET',
            }),
            providesTags: ['Faq'],
        }),
        getQuetes: builder.query({
            query: ({ page, limit, searchData }) => ({
                url: `${apiEndpoints?.quotesGetUrl}?page=${page}&limit=${limit}&search_key=${searchData ?? ''}`,
                method: 'GET',
            }),
            providesTags: ['Quetes'],
        }),
        getInsult: builder.query({
            query: ({ page, limit, searchData }) => ({
                url: `${apiEndpoints?.insultGetUrl}?page=${page}&limit=${limit}&search_key=${searchData ?? ''}`,
                method: 'GET',
            }),
            providesTags: ['Quetes'],
        }),
        addFaq: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.faqCommonUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        addQuetes: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.quotesAddUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        addInsult: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.addInsultUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        updateFaq: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.faqCommonUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        updateLanguage: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateLanguageUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        updateQuetes: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateQuetesUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        updateInsult: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.updateInsultUrl,
                method: "PUT",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        deleteFaq: builder.mutation({
            query: (faqId) => ({
                url: `${apiEndpoints?.faqCommonUrl}`,
                method: 'DELETE',
                body: { question_id: faqId }
            }),
            invalidatesTags: ['Faq'],
        }),
        deleteQuetes: builder.mutation({
            query: (id) => ({
                url: `${apiEndpoints?.deleteQuetesUrl}`,
                method: 'DELETE',
                body: { quote_id: id }
            }),
            invalidatesTags: ['Quetes'],
        }),
        deleteInsult: builder.mutation({
            query: (id) => ({
                url: `${apiEndpoints?.deleteInsultUrl}`,
                method: 'DELETE',
                body: { insult_id: id }
            }),
            invalidatesTags: ['Quetes'],
        }),
        uploadQuotesFile: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.uploadQuotesFileUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        uploadInsultFile: builder.mutation({
            query: (commonData) => ({
                url: apiEndpoints?.uploadInsultFileUrl,
                method: "POST",
                body: commonData
            }),
            invalidatesTags: ['Faq'],
        }),
        getOrders: builder.query({
            query: ({ page, limit, searchData }) => ({
                url: `${apiEndpoints?.getOrdersUrl}?page=${page}&limit=${limit}${searchData ? `&search_key=${searchData}` : ''}`,
                method: 'GET',
            }),
            providesTags: ['Orders'],
        }),
        getOrderDetails: builder.query({
            query: ({ order_id }) => ({
                url: `${apiEndpoints?.getOrderDetailsUrl}?order_id=${order_id}`,
                method: 'GET',
            }),
            providesTags: ['Orders'],
        }),
        updateOrder: builder.mutation({
            query: (orderData) => ({
                url: apiEndpoints?.updateOrderUrl,
                method: "PUT",
                body: orderData
            }),
            invalidatesTags: ['Orders'],
        }),
    })
});

export const {
    useGetCommonDataQuery,
    useGetPromptDataQuery,
    useGetPromptDetailsDataQuery,
    useUpdatePromptDataMutation,
    useUpdateCommonDataMutation,
    useGetFaqQuery,
    useUpdateFaqMutation, useAddFaqMutation,
    useDeleteFaqMutation,
    useGetQuetesQuery,
    useAddQuetesMutation,
    useUpdateQuetesMutation,
    useDeleteQuetesMutation,
    useUploadQuotesFileMutation,
    useGetInsultQuery,
    useAddInsultMutation,
    useUpdateInsultMutation,
    useDeleteInsultMutation,
    useUploadInsultFileMutation,
    useUpdateLanguageMutation,
    useGetOrdersQuery,
    useGetOrderDetailsQuery,
    useUpdateOrderMutation
} = commonApi;
